import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './assets/theme.css'

// Vue.prototype.$http = Axios

// Vue.config.productionTip = false

// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')

const app = Vue.createApp(App)
if (store.getters.authToken) {
  axios.defaults.headers.common['Authorization'] = store.getters.authToken
}
app.use(store)
app.use(router)

if (process.env.NODE_ENV === 'production') {
  const checkVersion = setupAppVersionCheck()
  router.afterEach(checkVersion)
}

app.mount("#app")

function setupAppVersionCheck() {
  let loadedVersion = null
  let bannerShown = false

  function showUpdateBanner() {
    if (bannerShown) return
    bannerShown = true

    const banner = document.createElement('div')
    banner.id = 'app-update-banner'
    banner.style.cssText =
      'position:fixed;top:0;left:0;right:0;z-index:9999;padding:10px 16px;' +
      'background:#fff3cd;border-bottom:1px solid #ffc107;text-align:center;font-size:14px;'
    banner.innerHTML =
      'A new version is available. ' +
      '<button type="button" class="btn btn-sm btn-warning" style="margin-left:8px;">Refresh now</button>'
    banner.querySelector('button').addEventListener('click', () => window.location.reload())
    document.body.prepend(banner)
  }

  function checkVersion() {
    fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (!data?.version) return
        if (!loadedVersion) {
          loadedVersion = data.version
          return
        }
        if (data.version !== loadedVersion) {
          showUpdateBanner()
        }
      })
      .catch(() => {})
  }

  return checkVersion
}
